
export class EnvironmentService {
  
  get is2Eskimos() {
    return this.env.instance === 1;
  }
  
  get isKutubee() {
    return this.env.instance === 2;
  }
  
  get is2bap() {
    return this.env.instance === 3;
  }
  
  env = {};
  
  constructor() {
    this.env = process.env;
  }
  
}
